
export const searchMain = [
  {
    name: 'search',
    path: '/search',
    meta: {
      title: '数据查询',
      icon: 'shezhi'
    }
  },
  {
    name: 'searchList',
    path: '/search/list',
    component: () => import('/@/views/plugins/search/List.vue'),
    meta: { title: '查询列表' }
  },
  {
    name: 'searchHandle',
    path: '/search/handle',
    component: () => import('/@/views/plugins/search/Handle.vue'),
    meta: {
      title: '新增查询',
      path: '/search/handle'
    }
  },
  {
    name: 'searchHandle',
    path: '/search/handle/:id',
    component: () => import('/@/views/plugins/search/Handle.vue'),
    meta: {
      title: '查询编辑',
      // 增加一个动态路由标识，用于页面头部屑识别
      trendsRoute: true,
      path: '/search/handle'
    }
  }
]
